import {getStoredAuthToken} from '../utils/authToken'

export const checkLogin = () => {
    return getStoredAuthToken() !== null;
}
